import React from 'react'
import PropTypes from 'prop-types'

export const PrintWrapper = React.forwardRef((props, ref) => {
  return <div className='print-source' ref={ref}>{props.children}</div>
})

PrintWrapper.displayName = 'PrintWrapper'

PrintWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}
